module.exports = __webpack_public_path__ + "static/media/s97ga02.1a9000a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/s97ga02.jpg
// module id = 267
// module chunks = 0